export const SIDE_MENU_KEY = {
  ALL_WATCHLIST: 'ALL_WATCHLIST',
  PRICE_ALERT: 'PRICE_ALERT',
  RUNNING_TRADE: 'RUNNING_TRADE',
  MOVERS: 'MOVERS',
  VALUATION: 'VALUATION',
  BANDAR_DETECTOR: 'BANDAR_DETECTOR',
};

export const baseMenu = [
  {
    key: SIDE_MENU_KEY.ALL_WATCHLIST,
    icon: 'icon-widget_watchlist',
    text: 'Watchlist',
    eventName: 'watchlist',
  },
];

export const indonesiaMenu = [
  {
    key: SIDE_MENU_KEY.PRICE_ALERT,
    icon: 'icon-widget_alert',
    text: 'Price Alert',
    eventName: 'price_alert',
  },
  {
    key: SIDE_MENU_KEY.RUNNING_TRADE,
    icon: 'icon-widget_runningtrade',
    text: 'Running Trade',
    eventName: 'running_trade',
  },
  {
    key: SIDE_MENU_KEY.MOVERS,
    icon: 'icon-widget_hotlist',
    text: 'Movers',
    eventName: 'movers',
  },
  {
    key: SIDE_MENU_KEY.VALUATION,
    icon: 'icon-widget_valuation',
    text: 'Valuation',
    eventName: 'valuation',
  },
  {
    key: SIDE_MENU_KEY.BANDAR_DETECTOR,
    icon: 'icon-widget_bandar',
    text: 'Bandar Detector',
    eventName: 'bandar_detector',
  },
];
